import React, { useState } from 'react';
import { MediaSkeleton } from '../../atoms/media/media-skeleton';
import { MediaModal } from '../../atoms/media/media-modal';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { Typography } from '@material-tailwind/react';
import { PiFilePdf } from 'react-icons/pi';
import Tooltip from 'src/modules/shared/components/atoms/tooltips/tooltip';

interface PdfMediaProps {
  url: string;
  fileName: string;
  isLoading?: boolean;
  className?: string;
  footer?: React.ReactNode;
}

export const PdfMedia: React.FC<PdfMediaProps> = ({
  url,
  fileName,
  isLoading = false,
  className = '',
  footer = null,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const containerClasses = `flex relative w-full h-auto max-w-[27rem] max-h-[27rem] rounded-lg ${className}`;

  const handleOpenModal = () => setIsModalOpen(true);

  return (
    <>
      <div className="flex flex-col gap-2 justify-start w-full">
        <div className={containerClasses}>
          {isLoading && <MediaSkeleton type="file" />}

          {/* TODO: check when implementing i18n */}
          <Tooltip content="Ver PDF" placement="top" size="sm">
            <Button
              variant="secondary"
              appearance="soft"
              size="lg"
              onClick={handleOpenModal}
              className={`!h-14 w-64 max-w-full justify-between items-center ${
                !isLoading ? 'flex' : 'hidden'
              }`}
            >
              <Typography className="flex flex-1 min-w-0 text-sm font-normal text-primary-600 text-left whitespace-normal break-words line-clamp-2">
                {fileName}
              </Typography>

              <PiFilePdf className="w-5 h-5 text-primary-600" />
            </Button>
          </Tooltip>
        </div>

        {footer && footer}
      </div>

      <MediaModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <iframe
          src={url}
          title={fileName}
          className="max-h-[85vh] max-w-[85vw] w-[85vw] h-[85vh] rounded-lg"
        />
      </MediaModal>
    </>
  );
};

export default PdfMedia;
